import ThreatTab from './ThreatTab';

export default ThreatTab;
